export class ConductDeviceModel {
  model: string;
  flag_status: string;

  constructor(model, status) {
    this.model = model;
    this.flag_status = status;
  }
}
